import React from 'react'

export default ({ step: {step_img}, toggleMap }) => (
  <div className="block block--map">
    <div className="map" onClick={() => toggleMap()}>
      <img className="map__image" src={step_img.url} alt={step_img.alt} />
    </div>
  </div>
)


// WEBPACK FOOTER //
// ./src/components/Block/BlockMap/BlockMap.js